import { createSlice } from "@reduxjs/toolkit";
import moment from "moment";
const initialState = {
    fromServiceCalenderDate:moment(new Date()).format("YYYY-MM-DD"),
    toServiceCalenderDate:moment(new Date()).format("YYYY-MM-DD"),
    showServiceCalenderTable:false,
    serviceCalenderData:[],
    serviceCalenderListingFilters:{},
}

const serviceCalenderSlice = createSlice({
    name: "serviceCalender",
    initialState,
    reducers: {
        fromServiceCalenderDateInfo: (state, { payload }) => {
            state.fromServiceCalenderDate = payload;
        },
        toServiceCalenderDateInfo: (state, { payload }) => {
            state.toServiceCalenderDate = payload;
        },
        showServiceCalenderTableInfo:(state, {payload}) => {
            state.showServiceCalenderTable = payload;
        },
        serviceCalenderListingFiltersInfo:(state,{payload}) =>{
            state.serviceCalenderListingFilters=payload;
        },
        serviceCalenderDataInfo:(state, {payload}) => {
            state.serviceCalenderData = payload;
        },
      
    }
})

const { reducer, actions } = serviceCalenderSlice;

export const {fromServiceCalenderDateInfo, toServiceCalenderDateInfo,
     showServiceCalenderTableInfo, serviceCalenderDataInfo, 
     serviceCalenderListingFiltersInfo} =actions;

export default reducer;


